import { Input } from 'alurkerja-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormField, IFormField } from './FormField';

interface TextAreaFieldProps extends IFormField {
  placeholder?: string;
  hidden?: boolean;
  maxLength?: number;
  showCount?: boolean;
}

export const TextAreaField: React.FC<TextAreaFieldProps> = props => {
  const form = useFormContext();
  const shouldShowCount = Boolean(props.showCount);

  return (
    <FormField
      {...props}
      render={({ field }) => {
        const valueLength =
          typeof field.value === 'string'
            ? field.value.length
            : field.value
              ? String(field.value).length
              : 0;

        return (
          <div>
            <Input
              placeholder={props.placeholder ?? 'Enter text here'}
              id={props.name}
              value={field.value}
              onChange={e => {
                field.onChange(e.target.value);
                if (props.maxLength && form?.trigger) {
                  form.trigger(props.name);
                }
              }}
              textArea
              disabled={props.disabled}
              hidden={props.hidden}
            />
            {shouldShowCount && (
              <div className="mt-1 flex justify-end text-xs text-gray-500">
                <span
                  data-testid={`${props.name}-character-count`}
                  className={
                    props.maxLength && valueLength > props.maxLength
                      ? 'font-medium text-red-500'
                      : ''
                  }
                >
                  {valueLength}
                  {props.maxLength ? ` / ${props.maxLength}` : ''}
                </span>
              </div>
            )}
          </div>
        );
      }}
    />
  );
};
